// extracted by mini-css-extract-plugin
export default {"label":"reviewSpotInstructions_label__kzwYE","attachment":"reviewSpotInstructions_attachment__zYFrB"};